import React from "react";

const Delete = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8718 16.4999H3.2954C3.19567 16.4999 3.09595 16.3999 3.09595 16.2999L1.00171 3.49994C1.00171 3.39994 1.10143 3.19995 1.20116 3.19995C1.40061 3.19995 1.50034 3.29993 1.50034 3.39993L3.49484 15.9999H11.5726L13.2679 5.19995C13.2679 5.09995 13.3677 4.99994 13.5671 4.99994C13.6668 4.99994 13.7666 5.19993 13.7666 5.29993L11.9715 16.3999C12.0712 16.3999 11.9715 16.4999 11.8718 16.4999Z"
        fill="black"
      />
      <path
        d="M13.8659 3.60001H1.20078C1.10105 3.60001 0.901611 3.49999 0.901611 3.29999C0.901611 3.19999 1.00132 3 1.20078 3H13.8659C13.9656 3 14.1651 3.09999 14.1651 3.29999C14.1651 3.49999 14.0654 3.60001 13.8659 3.60001Z"
        fill="black"
      />
      <path
        d="M5.68857 3.49997C5.58884 3.49997 5.3894 3.39998 5.3894 3.19998V1.19998C5.3894 1.09998 5.48912 0.899963 5.68857 0.899963H9.47814C9.57786 0.899963 9.77732 0.999982 9.77732 1.19998V2.29996C9.77732 2.39996 9.67759 2.59998 9.47814 2.59998C9.27869 2.59998 9.17896 2.49996 9.17896 2.29996V1.49997H5.88803V3.19998C5.88803 3.39998 5.78829 3.49997 5.68857 3.49997Z"
        fill="black"
      />
      <path
        d="M7.68295 14.5C7.58323 14.5 7.38379 14.4 7.38379 14.2V5.79999C7.38379 5.69999 7.4835 5.5 7.68295 5.5C7.8824 5.5 7.98213 5.59999 7.98213 5.79999V14.2C7.88241 14.4 7.78268 14.5 7.68295 14.5Z"
        fill="black"
      />
      <path
        d="M9.77745 14.5C9.67773 14.5 9.67773 14.5 9.77745 14.5C9.578 14.5 9.47827 14.3 9.47827 14.2L10.675 5.79996C10.675 5.69996 10.7747 5.59998 10.9742 5.59998C11.0739 5.59998 11.1736 5.69996 11.1736 5.89996L9.9769 14.3C9.9769 14.4 9.87718 14.5 9.77745 14.5Z"
        fill="black"
      />
      <path
        d="M5.38944 14.5C5.28971 14.5 5.18998 14.4 5.09026 14.3L3.89355 5.89996C3.89355 5.79996 3.99328 5.59998 4.093 5.59998C4.19273 5.59998 4.39218 5.69996 4.39218 5.79996L5.58888 14.2C5.68861 14.3 5.58889 14.5 5.38944 14.5Z"
        fill="black"
      />
    </svg>
  );
};

export default Delete;
